const component = {

    /**
     * Init component
     * 
     * @returns {boolean|undefined}
     */
	init: () => {

        component.target = document.querySelectorAll('[data-tooltip]');

        if (!component.target)
            return false;

        component.target.forEach(tooltip => {
            component._initEvents(tooltip);
        });
	},

    /**
	 * Start to listen the click button
     * 
     * @param {object} tooltip A tooltip object.
     * @returns {undefined}
	 */
	_initEvents: (tooltip) => {

        if(tooltip) {

            var container = tooltip.querySelector('[data-tooltip-items]');

            tooltip.querySelector('[data-tooltip-link]').addEventListener('click', event => {
                event.preventDefault();

                //If it is already activated
                if(tooltip.classList.contains("active")) {
                    container.classList.remove("active");
                    tooltip.classList.remove("active");
                    document.body.classList.remove("tooltip-open");

                    //disable focus trap
                    component._disableFocusTrap();

                    //disable overlay
                    component._disableOverlay(tooltip);
                }
                else {
                    //init tooltip focus trap
                    component._initFocusTrap(tooltip);

                    //active tooltip focus trap
                    component._activeFocusTrap();

                    //focus tooltip element
                    tooltip.focus();
        
                    if(container) {
                        //add active classes
                        container.classList.add("active");
                        tooltip.classList.add("active");
                        document.body.classList.add("tooltip-open");
                    }

                    //enable page overlay
                    component._enableOverlay();
                }
            });

            // Close icons div on press escape
            window.addEventListener('escape', (event) => {
                event.preventDefault();
            
                if(container) {
                    container.classList.remove("active");
                    tooltip.classList.remove("active");
                    document.body.classList.remove("tooltip-open");
                }

                //disable focus trap
                component._disableFocusTrap();

                //disable overlay
                component._disableOverlay(tooltip);
            });

            // Close tooltip when click on overlay
            document.querySelectorAll('[data-tooltip-close]').forEach(overlay => {

                overlay.addEventListener('click', (event) => {
                    event.preventDefault();

                    if(container) {
                        container.classList.remove("active");
                        tooltip.classList.remove("active");
                        document.body.classList.remove("tooltip-open");
                    }
                    
                    //disable focus trap
                    component._disableFocusTrap();

                    //disable overlay
                    component._disableOverlay(overlay);
                });

                
            });
        }
	},

    /**
	 * Enable tooltip overlay
     * 
     * @returns {undefined}
	 */
	_enableOverlay: () => {
        document.querySelectorAll('[data-tooltip-close]').forEach(overlay => {
            overlay.classList.add('active');
        });
	},

    /**
	 * Disable tooltip overlay
     * 
	 * @param {object} tooltip A tooltip object.
	 * @returns {undefined}
	 */
	_disableOverlay: (overlay) => {
        document.querySelectorAll('[data-tooltip-close]').forEach(overlay => {
            overlay.classList.remove('active');
        });
	},

    /**
	 * Init tooltip focus trap
     * 
     * @param {object} currently_tooltip A tooltip object.
     * @returns {undefined}
	 */
     _initFocusTrap: (currently_tooltip) => {

        //Disable the last element with docus trap enabled
        if(component.focusTrap) {
            component._disableFocusTrap();
        }

        component.target.forEach(tooltip => {
            if(currently_tooltip == tooltip) {
                component.focusTrap = focusTrap.createFocusTrap(currently_tooltip, { clickOutsideDeactivates: true });
            }
        });
    },

    /**
	 * Active tooltip focus trap
     * 
     * @returns {undefined}
	 */
	 _activeFocusTrap: () => {

        if (component.focusTrap) {
            component.focusTrap.activate();
        }
    },

    /**
	 * Disable tooltip focus trap
     * 
     * @returns {undefined}
	 */
	_disableFocusTrap: () => {

		if (component.focusTrap) {
			component.focusTrap.deactivate();
		}
	}
};

export default component;
